export default __webpack_public_path__ + "static/media/light.e0c63b86.woff";